/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmExecutionQueryFilters {
    getFixupPrototypeFunction() { return AwsSsmExecutionQueryFilters.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmExecutionQueryFilters>): AwsSsmExecutionQueryFilters {
        let obj = Object.assign(new AwsSsmExecutionQueryFilters(), model);
        AwsSsmExecutionQueryFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmExecutionQueryFilters>): AwsSsmExecutionQueryFilters {
        if (!model) return null;
        return AwsSsmExecutionQueryFilters.newInstance(<AwsSsmExecutionQueryFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmExecutionQueryFilters) {
        if (!obj) return;

        models.AwsSsmExecutionQueryFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmExecutionQueryFilters): boolean {
        Object.setPrototypeOf(obj, AwsSsmExecutionQueryFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * status of the execution (all if missing)
     */
    status: Array<string>;

    /**
     * The name of the document (all if missing)
     */
    document_names: Array<string>;

    /**
     * IAM ARN of the user who executed the document (all if missing)
     */
    executed_by: Array<string>;

}
